export default __webpack_public_path__ + "static/coupon-f29d0937231209ea030886cbea247a43.png";